import { householdActions } from "@/redux/household/household-slice";
import { useEffect } from "react";
import { useAppDispatch } from "./useAppDispatch";

const useHeaderChangeNoUP = (title: string) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(householdActions.setHeader({ title: title, content: "" }));

    return () => {
      dispatch(householdActions.setHeader({ title: "", content: "" }));
    };
  }, [dispatch, title]);
};

export default useHeaderChangeNoUP;
